/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-28T14:19:44.384
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getFinancialCollectionItemEditInit,
	getFinancialCollectionItemView
} from '@api/financial/FinancialCollectionItem';

import {
listFinancialCollectionDetailInit,
listFinancialCollectionDetailByAuthorizations,
deleteFinancialCollectionDetail
} from '@api/financial/FinancialCollectionDetail';

import {
listFinancialCollectionCoupontInit,
listFinancialCollectionCoupontByAuthorizations,
deleteFinancialCollectionCoupont
} from '@api/financial/FinancialCollectionCoupont';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
		AdvanceQuery: cloneObj(RespCommonDef.AdvanceQuery)
	},
	actions: {
		getFinancialCollectionItemEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getFinancialCollectionItemEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getFinancialCollectionItemView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getFinancialCollectionItemView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
